import React, { useState, useEffect } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import Resizer from "react-image-file-resizer";
import moment from 'moment';
import Swal from 'sweetalert2';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles({
    imageCropContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '30px',
    },
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        marginTop: '2em',
        gap: '30px',
    },
    modalButton: {
        width: '150px',
        color: 'white',
        border: '1px solid white',
        padding: '10px',
        borderRadius: '5px',

        '&:hover': {
            color: 'white',
            border: '1px solid white',
        }
    },
    red: {

        backgroundColor: '#f76161',
        '&:hover': {
            backgroundColor: '#972525',
        }
    },
    green: {
        backgroundColor: '#45b77c',
        '&:hover': {
            backgroundColor: '#308c5c',
        }
    },

});
const ImageCrop = ({ src, onImageLoaded, circularCrop, getImage, cropCancel }) => {



    const classes = useStyles();

    const cropData = {
        unit: 'px',
        width: 200,
        height: 200,
        x: 10,
        y: 10,
    }
    const [crop, setCrop] = useState({});
    const [image, setImage] = useState('');

    const resizeFile = (files) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                files,
                800,
                400,
                "JPEG",
                100,
                0,
                (url) => {
                    resolve(url);
                },
                "base64"
            );
        });

    const resize = async () => {
        if (src?.name.includes('.svg')) {
            if (src.size > 10000) {
                const resizedImage = await resizeFile(src);
                setImage(resizedImage);
            }
            else {
                cropCancel();
                Swal.fire({
                    title: 'Error!',
                    text: 'Image Size is Too Small',
                    icon: 'error',
                    confirmButtonColor: 'green',
                    timer: 5000,
                });
            }

        }
        else {
            const resizedImage = await resizeFile(src);
            setImage(resizedImage);
        }
    }

    useEffect(() => {
        resize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [src])

    useEffect(() => {
        setCrop(cropData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])



    const getCroppedImg = async () => {
        try {
            const canvas = document.createElement('canvas');
            let pic = new Image();
            pic.fill = 'white'
            pic.src = image;
            const scaleX = pic.naturalWidth / pic.width;
            const scaleY = pic.naturalHeight / pic.height;

            if (crop.width === 0 && crop.height === 0) {
                crop.width = image.width;
                crop.height = image.height;
            }
            canvas.width = crop.width;
            canvas.height = crop.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(
                pic,
                crop.x * scaleX,
                crop.y * scaleY,
                crop.width * scaleX,
                crop.height * scaleY,
                0,
                0,
                crop.width,
                crop.height);
            const base64Image = canvas.toDataURL("image/jpeg", 1);
            dataURLtoFile(base64Image);
        } catch (err) {
            console.log(err);
        }
    };
    const dataURLtoFile = (dataUrl) => {
        const arr = dataUrl.split(',');
        const base64String = arr[1];
    
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
    
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
    
        const byteArray = new Uint8Array(byteNumbers);
        const croppedProfileImage = new File([byteArray], `cropped_${moment().format()}.jpeg`, {
            type: 'image/jpeg',
        });
    
        handleImage(croppedProfileImage);
    };
    const handleImage = (files) => {
        getImage(files);
        setCrop(cropData);
        setImage('');

    };
    return (
        <div className={classes.imageCropContainer}>
            {image && (<>
                <ReactCrop
                    src={image}
                    onImageLoaded={onImageLoaded}
                    crop={crop}
                    onChange={(c) => setCrop(c)}
                    circularCrop={circularCrop}
                >
                    <img src={image} alt='crop' />
                </ReactCrop>
                <div className={classes.buttonContainer}>
                    <button className={`${classes.modalButton} ${classes.green}`} onClick={getCroppedImg}>
                        Crop & Upload
                    </button>
                    <button className={`${classes.modalButton} ${classes.red}`} onClick={cropCancel}>
                        Cancel
                    </button>
                </div>
            </>)}
        </div>
    )
}

export default ImageCrop;